export default __webpack_public_path__ + "static/media/_IMG4854.2c915532.jpg";